import api from '@/lib/api';
import type { ShiftSummary, CashDrop, CashDropList } from './frontdeskOps.types';

export interface ShiftSummaryQuery {
  propertyId: string;
  date: string;
  /** Accepted for forward-compat; backend ignores it in Phase 1. */
  userId?: string | undefined;
}

export async function fetchShiftSummary(query: ShiftSummaryQuery): Promise<ShiftSummary> {
  const { data } = await api.get<ShiftSummary>('/shift/summary', { params: query });
  return data;
}

// ─── Cash Drops (Phase 2) ────────────────────────────────────────────────────

export interface RecordCashDropInput {
  propertyId: string;
  date: string;
  amount: number;
  note?: string;
}

export async function recordCashDrop(input: RecordCashDropInput): Promise<CashDrop> {
  const { data } = await api.post<CashDrop>('/shift/cash-drop', input);
  return data;
}

export interface CashDropsQuery {
  propertyId: string;
  date: string;
}

export async function fetchCashDrops(query: CashDropsQuery): Promise<CashDropList> {
  const { data } = await api.get<CashDropList>('/shift/cash-drops', { params: query });
  return data;
}
